class ReviewCarousel extends HTMLElement {
  connectedCallback() {
    this.abort?.abort();
    this.resize?.disconnect();
    this.abort = new AbortController();
    const options = { signal: this.abort.signal };
    this.track = this.querySelector('[data-track]');
    this.cards = this.track?.querySelectorAll(':scope > .rl-review-carousel__card, :scope > product-card');
    this.controls = this.querySelector('[data-controls]');
    this.progress = this.querySelector('[data-progress]');
    this.previous = this.querySelector('[data-prev]');
    this.next = this.querySelector('[data-next]');
    if (!this.track || !this.cards.length) return;
    this.previous.addEventListener('click', () => this.move(-1), options);
    this.next.addEventListener('click', () => this.move(1), options);
    this.track.addEventListener('scroll', () => this.updateProgress(), { ...options, passive: true });
    this.track.addEventListener('keydown', (event) => {
      if (event.target !== this.track || !['ArrowLeft', 'ArrowRight', 'Home', 'End'].includes(event.key)) return;
      event.preventDefault();
      if (event.key === 'ArrowLeft' || event.key === 'ArrowRight') {
        this.move(event.key === 'ArrowRight' ? 1 : -1);
      } else {
        this.track.scrollTo({ left: event.key === 'Home' ? 0 : this.track.scrollWidth, behavior: this.scrollBehavior });
      }
    }, options);
    this.resize = new ResizeObserver(() => this.updateProgress());
    this.resize.observe(this.track);
    this.updateProgress();
  }

  disconnectedCallback() {
    this.abort?.abort();
    this.resize?.disconnect();
  }

  get scrollBehavior() {
    return matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth';
  }

  move(direction) {
    const gap = parseFloat(getComputedStyle(this.track).columnGap) || 18;
    this.track.scrollBy({ left: direction * (this.cards[0].offsetWidth + gap), behavior: this.scrollBehavior });
  }

  updateProgress() {
    const max = Math.max(0, this.track.scrollWidth - this.track.clientWidth);
    const position = Math.max(0, Math.min(max, this.track.scrollLeft));
    this.controls.hidden = max <= 1;
    this.progress.style.width = (max > 0 ? (position / max) * 75 + 25 : 100) + '%';
    this.previous.disabled = position <= 1;
    this.next.disabled = position >= max - 1;
  }
}

if (!customElements.get('rl-review-carousel')) customElements.define('rl-review-carousel', ReviewCarousel);
